export default __webpack_public_path__ + "static/media/Websites-Movies online.c471ee36.png";